<template lang="pug">
b-card.mb-1(no-body='')
  b-card-header.p-1.text-left(header-tag='header' role='tab')
    b-button.btn.text-left(block='' v-b-toggle.accordion-settingmenu='' variant='primary') {{ $t('ui.setting_menu') }}
  b-collapse#accordion-settingmenu(visible=''  role='tabpanel')
    b-card-body
      b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
        b-form-group(:label="$t('ui.content')")
          //- https://www.jsdelivr.com/package/npm/vue-draggable-nested-tree#id-examples
          //- https://github.com/phphe/vue-draggable-nested-tree/blob/master/src/examples/MaxLevel.vue
          //- https://codepen.io/alucardxpmusic/pen/pQNvdz
          Tree(:data="settingMenuData" draggable @drag="ondragsetting" )
            div.tree-node-inner-el.text-dark(slot-scope="{data, store}" v-if="data.text" :class="setClassBg(data)")
              div
                span.white-space-initial {{ $t('ui.menulist.' + data.text) }}
              div
                input.ml-2.pointer.align-middle(type="checkbox" name="settingmenuhidden" v-model="data.is_hidden" :true-value="false" :false-value="true")

        //- .row
        //-   .col
        //-     b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}

        div.d-flex.justify-content-between.mb-3
          b-button(type="button" variant="info" size="sm" @click="refreshList")
            i.fa.fa-sync
            span.ml-1 {{ $t("ui.reset") }}
          div
            SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')")
            b-button.ml-2(type="button" variant="info" @click="callSync")
              i.fas.fa-sync-alt
              span.ml-1 {{ $t("ui.sync_all") }}
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import { DraggableTree } from "vue-draggable-nested-tree";
import * as th from 'tree-helper'

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    Tree: DraggableTree
  },
  props: {
    siteId: {
      type: Number
    },
    settingMenuList: {
      type: Array
    },
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      settingMenuData: [],
      data: null,
      maxLevel: 2,
      settingMenuListDefault: []
    };
  },
  computed: {
    selectedOperatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  mounted() {
    this.settingMenuListDefault = this.settingMenuList;
    this.setSettingMenuVal()
  },
  methods: {
    refreshList() {
      this.setSettingMenuVal()
    },
    setClassBg(data) {
      var setClass = ''
      if(data.is_hidden) setClass = 'tree-hidden'
      if(data.position == 'HEADER') setClass += ' tree-header-color'

      return setClass
    },
    setSettingMenuVal() {
      var menuList = this.settingMenuListDefault
      var parentList = [];
      var childList = [];

      for(var i = 0; i < menuList.length; i++) {
        var json = {};
        var parentId = menuList[i].parent_content_id

        if(parentId == null) {

          json = {
            text: menuList[i].content_id,
            content_id: menuList[i].content_id,
            is_hidden: menuList[i].is_hidden,
            position: menuList[i].position,
            theme_content_group: menuList[i].theme_content_group,
            children: []
          }
          parentList.push(json)
        } else {
          json = {
            parent_content_id: menuList[i].parent_content_id,
            text: menuList[i].content_id,
            is_hidden: menuList[i].is_hidden,
            position: menuList[i].position,
            theme_content_group: menuList[i].theme_content_group
          }
          childList.push(json)
        }
      }

      for(var i = 0; i < parentList.length; i++) {
        var contentId = parentList[i].content_id
        for(var j = 0; j < childList.length; j++) {
          var parentId = childList[j].parent_content_id
          if(contentId == parentId) {
            parentList[i].children.push(childList[j])
          }
        }
      }

      this.settingMenuData = parentList
    },
    ondragsetting(node) {
      var currMaxLevel = this.maxLevel;
      if(node.position == 'HEADER') {
        currMaxLevel = 1
      }
      const {maxLevel} = this
      let nodeLevels = 1
      th.depthFirstSearch(node, (childNode) => {
        if (childNode._vm.level > nodeLevels) {
          nodeLevels = childNode._vm.level
        }
      })
      nodeLevels = nodeLevels - node._vm.level + 1
      // const childNodeMaxLevel = maxLevel - nodeLevels
      const childNodeMaxLevel = currMaxLevel - nodeLevels
      //
      th.depthFirstSearch(this.settingMenuData, (childNode) => {
        if (childNode === node) {
          return 'skip children'
        }
        // if (!childNode._vm) {
        //   console.log(childNode);
        // }
        this.$set(childNode, 'droppable', childNode._vm.level <= childNodeMaxLevel)
      })
    },
    getSettingMenuData() {
      var menuList = this.settingMenuData
      var list = []
      var sequence = 0;

      for(var i = 0; i < menuList.length; i++) {
        var json = {}
        var child = menuList[i].children
        sequence = sequence + 1;
        json = {
          // position: position,
          position: menuList[i].position,
          sequence: sequence,
          is_hidden: menuList[i].is_hidden,
          parent_content_id: null,
          content_id: menuList[i].text
        }
        list.push(json)

        if(child.length > 0) {
          for(var j = 0; j < child.length; j++) {
            sequence = sequence + 1;
            json = {
              // position: position,
              position: child[j].position,
              sequence: sequence,
              is_hidden: child[j].is_hidden,
              parent_content_id: menuList[i].text,
              content_id: child[j].text
            }
            list.push(json)
          }
        }
      }
      return list
    },
    submit() {
      var settingList = this.getSettingMenuData();
      let url = config.siteThemeContentEditUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        operator_id: this.selectedOperatorID,
        site_id: this.siteId,
        content_details: settingList,
        theme_content_group: "dropdown"
      };

      this.feedback.success = true;
      this.loading = true;

      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clickedMenu");
                this.settingMenuListDefault = settingList;
                this.refreshList()
                this.$helpers.showDialog(this.$t("ui.combine.update_setting_menu"), this.$t("message.success"), "success");
              } else {
                // this.$helpers.handleFeedback(this.feedback.status);
                this.handleFailed("update_setting_menu", this.feedback.status);
              }
            }
          } catch (error) {
            this.loading = false;
            if (error.status.toLowerCase() == "nochanges") {
              this.$emit("clicked");
            } else {
              this.feedback.success = false;
              this.feedback.status = error.status;
              // this.$helpers.handleFeedback(this.feedback.status);
              this.handleFailed("update_setting_menu", this.feedback.status);
            }
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.handleFeedback(this.feedback.status);
        }
      );
    },
    handleFailed: function(tag, status) {
      if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + status), "error");
      this.refreshList()
    },
    callSync() {
      this.$emit("callSync");
    }
  }
};
</script>